import React, { useEffect, useState, useRef, useMemo } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import Icon from 'components/UI/Icon';
import TechInfo from './TechInfo';

import { TEMPLATES_PAGE } from 'constants/urls';
import useGoScreverTemplateData from 'hooks/useGoScreverTemplateData';
// import useGoScreverTemplateEditLink from 'hooks/useGoScreverTemplateEditLink';

import { getScreverTemplateEditLink } from 'helpers/getScreverTemplateEditLink';

import * as styles from './inner.module.scss';
import '../common-hero.scss';
import 'styles/common/_flags.scss';

const Inner = ({ data }) => {
  const {
    templateInnerHero: {
      templateInnerHeroBackButton,
      templateInnerHeroMainButton,
      templateInnerHeroTemplate: {
        goScreverTemplates: { goScreverTemplatesId },
      },
    },
  } = data;

  const TEMPLATE_ID = goScreverTemplatesId;
  // const USE_TEMPLATE = useGoScreverTemplateEditLink(TEMPLATE_ID);
  const USE_TEMPLATE = useMemo(() => getScreverTemplateEditLink(TEMPLATE_ID), [
    TEMPLATE_ID,
  ]);

  const [showFullScreenBtn, setShowFullScreenBtn] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const wrapScroll = useRef(null);

  const {
    name,
    description,
    tag,
    link,
    questionsCount,
    approximateTime,
    defaultLocale,
  } = useGoScreverTemplateData(TEMPLATE_ID);

  useEffect(() => {
    setShowFullScreenBtn((state) => !state);
  }, []);

  const onFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    const refs = wrapScroll.current;

    if (isFullScreen) {
      disableBodyScroll(refs, { reserveScrollBarGap: true });

      return () => {
        enableBodyScroll(refs);
      };
    }
  }, [isFullScreen]);

  const langClass = defaultLocale?.toLowerCase();

  return (
    <div className={classnames('scr-template-hero-inner')}>
      <div
        ref={wrapScroll}
        className={classnames(
          styles.media,
          {
            [styles.fullScreen]: isFullScreen,
          },
          'scr-template-hero-inner__media'
        )}
      >
        {showFullScreenBtn && (
          <button
            type="button"
            onClick={onFullScreen}
            className={classnames(
              styles.fullScreenBtn,
              'scr-small src-mask-icon icon-fullscreen'
            )}
          >
            {!isFullScreen ? 'Open in the full screen' : 'Close full screen'}
          </button>
        )}

        <iframe
          className={classnames(styles.iframe, 'scr-custom-scroll')}
          title="preview"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          src={link}
        ></iframe>
      </div>

      <div
        className={classnames(
          styles.content,
          'scr-template-hero-inner__content'
        )}
      >
        <Link
          className={classnames('scr-template-conten-btn-back scr-link')}
          to={TEMPLATES_PAGE}
          id="link-template-back"
        >
          <Icon name="chevron-left" /> {templateInnerHeroBackButton}
        </Link>

        <h3 className={classnames('scr-template-conten-title scr-h3')}>
          {name}
        </h3>

        <div
          className={classnames(
            styles.additional,
            'scr-template-conten-additional'
          )}
        >
          <TechInfo
            tag={tag}
            questionCount={questionsCount}
            time={approximateTime}
          />
        </div>

        <p className={classnames('scr-template-conten-description')}>
          {description}
        </p>

        <div className={classnames(styles.info)}>
          <div className={classnames(styles.lang)}>
            <span
              className={classnames(styles.lang_flag, `scr-${langClass}`)}
            ></span>

            <span className={classnames(styles.lang_text)}>
              {defaultLocale}
            </span>
          </div>

          <a
            target="_blank"
            rel="noopener noreferrer"
            className={classnames(styles.mainBtn, 'scr-btn')}
            href={USE_TEMPLATE}
            id="link-use-template"
          >
            <span>
              {templateInnerHeroMainButton.templateInnerHeroMainButtonText}
            </span>

            <span className={styles.arrow}>
              <Icon name="arrow-right" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Inner;
